import * as server from "@/utils/http"

export const _page = params => server.get("/collection-log/page", params);

export const _get = params => server.get("/collection-log/get", params);
